import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { IRecipient } from '@tiendanube/common';
import recipientService from '../recipientService';
import { RecipientState } from '../types';

const initialState: RecipientState = {
  getRecipient: {
    data: null,
    status: 'idle',
  },
  updateRecipient: {
    data: null,
    status: 'idle',
  },
};

export const getRecipientAction = createAsyncThunk(
  'pagoNubeOnboarding/getRecipientAction',
  async (payload: { storeId: string; withRetry?: boolean }) =>
    await recipientService.getRecipient(payload.storeId, payload.withRetry),
);

export const updateRecipientAction = createAsyncThunk(
  'pagoNubeOnboarding/updateRecipientAction',
  async (payload: { storeId: string; recipient: IRecipient }) =>
    await recipientService.updateRecipient(payload.storeId, payload.recipient),
);

const recipientSlice = createSlice({
  name: 'recipient',
  initialState,
  reducers: {
    resetGetRecipientAction(state) {
      state.getRecipient.status = 'idle';
      state.getRecipient.data = null;
    },
    resetUpdateRecipientAction(state) {
      state.updateRecipient.status = 'idle';
      state.updateRecipient.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getRecipientAction.pending, (state) => {
        state.getRecipient.status = 'loading';
      })
      .addCase(getRecipientAction.fulfilled, (state, action) => {
        state.getRecipient.status = 'success';
        state.getRecipient.data = action.payload;
      })
      .addCase(getRecipientAction.rejected, (state) => {
        state.getRecipient.status = 'error';
      });
    builder
      .addCase(updateRecipientAction.pending, (state) => {
        state.updateRecipient.status = 'loading';
      })
      .addCase(updateRecipientAction.fulfilled, (state, action) => {
        state.updateRecipient.status = 'success';
        state.updateRecipient.data = action.payload;
      })
      .addCase(updateRecipientAction.rejected, (state) => {
        state.updateRecipient.status = 'error';
      });
  },
});

export const { reducer } = recipientSlice;

export const { resetGetRecipientAction, resetUpdateRecipientAction } =
  recipientSlice.actions;
